var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"70px"}},[(_vm.$store.state.status_flows)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }